// src/pages/cpaCareerQuiz/components/ProgressBar.jsx
export default function ProgressBar({ currentIndex, total }) {
  const pct = Math.round(((currentIndex) / total) * 100);
  return (
    <div className="quiz-progress mt-3">
      <div className="quiz-progress__meta">
        <span>進度</span>
        <span>{currentIndex + 1} / {total}</span>
      </div>
      <div className="quiz-progress__bar">
        <div className="quiz-progress__fill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
